import ReactGA from 'react-ga';
import {getQueryParameters, getCookieValue, capitalize} from './utils';

const GoogleAnalytics = {
    setCustomDimensions(props) {
        const params = getQueryParameters(props.location.search);

        const mapping = customDimensionMapping;

        const customDimensions = {};
        customDimensions[mapping.pagePath] = window.location.pathname;
        customDimensions[mapping.memberId] = params.apid || params.gaui || params.member_id || '';
        customDimensions[mapping.tcId] = params.tc || '';
        customDimensions[mapping.customTc] = params.subid || '';
        customDimensions[mapping.subCustomTc] = params.subid2 || '';
        customDimensions[mapping.apSessionId] = getCookieValue('apsessionid');
        customDimensions[mapping.blabId] = getCookieValue('blab');

        ReactGA.set(customDimensions);
    },
    sendPageview(props, title) {
        const {
            location: {pathname, search}
        } = props;
        const pageUrl = pathname + search;

        this.setCustomDimensions(props);

        ReactGA.pageview(pageUrl, undefined, title);
    },
    sendEngagementEvent(props, timeInSeconds) {
        const label = generateEngagementEventLabel(props);

        this.setCustomDimensions(props);

        ReactGA.event({
            category: 'Any Page',
            action: `Engagement ${timeInSeconds}`,
            label
        });
    }
};

const generateEngagementEventLabel = props => {
    const {
        assessment: {name, version},
        location
    } = props;

    const uriParts = location.pathname.split('/');
    const pageType = uriParts[3];

    const assessmentName = name
        .split('-')
        .map(word => capitalize(word))
        .join(' ');

    let label = `Assessment ${assessmentName} - ${version} - ${capitalize(pageType)}`;

    if (pageType.toLowerCase() == 'prompt') {
        const promptId = uriParts[4];
        const promptSuffix = ` - ${promptId}`;
        label += promptSuffix;
    }

    return label;
};

const customDimensionMapping = {
    pagePath: 'dimension41',
    memberId: 'dimension64',
    tcId: 'dimension66',
    customTc: 'dimension67',
    subCustomTc: 'dimension68',
    visitId: 'dimension70',
    apSessionId: 'dimension73',
    blabId: 'dimension76'
};

export default GoogleAnalytics;
